import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import type { SocialMediaAccounts, Shared } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    method: HTTP_METHODS.GET,
    url: `${CENTRAL_API_V3}/customers/@customerId/socialmedia/oauth`,
    paramOptions: { encode: true },
    query: {} as { redirectUrl?: string; type?: Extract<Shared.SocialPlatforms, 'tt'> },
    response: {} as SocialMediaAccounts.Get.OAuthUrl,
  },
};
